<template>
    <div class="c-o-request-section">
        <div v-if="hasImages" class="c-o-request-section__inner c-o-request-section__inner--centered  c-o-request-section__inner--no-padding-bottom">
            <div class="c-o-request-section__main c-o-request-section__main--small">
                <h2 class="c-o-request-section__title h2">Projektbilder</h2>
                <p class="c-o-request-section__body">Här kan du se beställarens bifogade bilder</p>
            </div>
        </div>
        <div v-if="hasImages" class="c-o-request-section__inner c-o-request-section__inner--no-padding-top">
            <div class="c-o-request-section__gallery">
                <carousel :altText="request.Title" :items="request.Images"></carousel>
            </div>
        </div>

        <div v-if="hasFiles" class="c-o-request-section__inner c-o-request-section__inner--centered  c-o-request-section__inner--no-padding-bottom no-print">
            <div class="c-o-request-section__main c-o-request-section__main--small">
                <h2 class="c-o-request-section__title h2">Filer</h2>
                <p class="c-o-request-section__body">Här kan du se beställarens bifogade filer</p>
            </div>
        </div>
        <div v-if="hasFiles" class="c-o-request-section__inner c-o-request-section__inner--no-padding-top no-print">
            <div class="c-o-request-section__filelist">
                <div v-for="file in request.Files" class="c-o-request-section__filelist-item">
                    <file-download :link="file" :label="fileName(file)" :icon="'file'" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Carousel from '../../molecules/MoleculeCarousel.vue'
    import FileDownload from '../../atoms/AtomFileDownload.vue'

    export default {
        props: [
            'request'
        ],
        components: {
            Carousel,
            FileDownload
        },
        computed: {
            hasImages: function(){
                return this.request.Images.length > 0;
            },
            hasFiles: function(){
                return this.request.Files.length > 0;
            }
        },
        methods: {
            fileName: function(str){
                return str.substring(str.lastIndexOf("/") + 1, str.length);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/request-sections/OrganismRequestSectionGallery.vue